import type { ReactElement } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import TruncatedTextWithTooltip from "../../../../common-components/TruncatedText/TruncatedTextWithTooltip";

import { StyledOpportunitySpottedErrorText } from "./styles";

const OpportunitySpottedErrorState = (): ReactElement => {
    return (
        <Stack
            height="100%"
            alignItems="center"
            data-automation="top-companies.opportunity-spotted-error"
        >
            <StyledOpportunitySpottedErrorText
                fontVariant="value"
                textAlign="center"
                color={colorsPalettes.midnight[400]}
            >
                {translate("si.top-companies.opportunity-spotted.error.title")}
            </StyledOpportunitySpottedErrorText>
            <TruncatedTextWithTooltip
                fontVariant="value"
                textAlign="center"
                color={colorsPalettes.midnight[400]}
            >
                {translate("si.top-companies.opportunity-spotted.error.subtitle")}
            </TruncatedTextWithTooltip>
        </Stack>
    );
};

export default OpportunitySpottedErrorState;
